/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Campaigns_HeadlineInputs */



/**
* | output |
* | --- |
* | "Giveaways that know who has been around." |
*
* @param {Products_Campaigns_HeadlineInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_campaigns_headline = /** @type {((inputs?: Products_Campaigns_HeadlineInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Campaigns_HeadlineInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Розыгрыши, которые знают, кто действительно бывает на сервере.")
	return /** @type {LocalizedString} */ ("Giveaways that know who has been around.")
});